export const SCHEMA = `
CREATE TABLE IF NOT EXISTS facultades (
    id TEXT PRIMARY KEY,
    nombre TEXT NOT NULL,
    sigla TEXT NOT NULL,
    disponible INTEGER NOT NULL,
    escala_calificacion_id TEXT,
    terminologia TEXT NOT NULL,
    design_tokens_ref TEXT
);

CREATE TABLE IF NOT EXISTS carreras (
    id TEXT PRIMARY KEY,
    facultad_id TEXT NOT NULL,
    nombre TEXT NOT NULL,
    tipo TEXT NOT NULL,
    creditos_totales INTEGER NOT NULL,
    duracion_semestres INTEGER NOT NULL,
    locacion TEXT NOT NULL,
    malla_precargada INTEGER NOT NULL,
    modo_vacio_confirmado INTEGER DEFAULT 0,
    FOREIGN KEY(facultad_id) REFERENCES facultades(id)
);

CREATE TABLE IF NOT EXISTS planes_estudio (
    id TEXT PRIMARY KEY,
    nombre TEXT NOT NULL,
    facultad TEXT NOT NULL,
    duracion_semestres INTEGER NOT NULL
);

CREATE TABLE IF NOT EXISTS escalas_calificacion (
    id TEXT PRIMARY KEY,
    facultad TEXT NOT NULL,
    nombre TEXT NOT NULL,
    niveles TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS modulos (
    id TEXT PRIMARY KEY,
    facultad_id TEXT NOT NULL,
    nombre TEXT NOT NULL,
    creditos_minimos INTEGER NOT NULL DEFAULT 0,
    color_hex TEXT,
    FOREIGN KEY(facultad_id) REFERENCES facultades(id)
);

CREATE TABLE IF NOT EXISTS ciclos (
    id TEXT PRIMARY KEY,
    facultad_id TEXT NOT NULL,
    nombre TEXT NOT NULL,
    creditos_minimos INTEGER NOT NULL DEFAULT 0,
    orden INTEGER NOT NULL DEFAULT 1,
    FOREIGN KEY(facultad_id) REFERENCES facultades(id)
);

CREATE TABLE IF NOT EXISTS acreditaciones_libres (
    id TEXT PRIMARY KEY,
    usuario_id TEXT,
    facultad_id TEXT NOT NULL,
    modulo_id TEXT,
    nombre_actividad TEXT NOT NULL,
    creditos INTEGER NOT NULL,
    fecha_acreditacion TEXT NOT NULL,
    FOREIGN KEY(facultad_id) REFERENCES facultades(id),
    FOREIGN KEY(modulo_id) REFERENCES modulos(id)
);

CREATE TABLE IF NOT EXISTS asignaturas (
    id TEXT PRIMARY KEY,
    plan_id TEXT NOT NULL,
    nombre TEXT NOT NULL,
    codigo TEXT,
    semestre_sugerido INTEGER,
    creditos INTEGER NOT NULL,
    departamento TEXT,
    facultad_origen TEXT,
    estado TEXT NOT NULL CHECK (estado IN ('no_iniciada', 'en_curso', 'cursando', 'a_examen', 'aprobada', 'abandonada', 'no_cursada', 'reprobada')),
    requisitos TEXT,
    periodo_cursado TEXT,
    fecha_inicio TEXT,
    fecha_fin TEXT,
    fecha_aprobacion TEXT,
    nota_final REAL,
    porcentaje_logro REAL,
    concepto_final TEXT,
    posicion_x REAL,
    posicion_y REAL,
    eva_url TEXT,
    sala9_url TEXT,
    ano_cursado INTEGER,
    en_papelera INTEGER DEFAULT 0,
    eliminado_en TEXT,
    es_opcional INTEGER DEFAULT 0,
    dictado TEXT,
    previas_sugeridas TEXT,
    calificacion_oficial INTEGER,
    aplazos TEXT,
    modulo_id TEXT,
    ciclo_id TEXT,
    FOREIGN KEY(plan_id) REFERENCES planes_estudio(id),
    FOREIGN KEY(modulo_id) REFERENCES modulos(id),
    FOREIGN KEY(ciclo_id) REFERENCES ciclos(id)
);

CREATE TABLE IF NOT EXISTS evaluaciones (
    id TEXT PRIMARY KEY,
    asignatura_id TEXT NOT NULL,
    tipo TEXT NOT NULL,
    nombre TEXT NOT NULL,
    fecha TEXT NOT NULL,
    porcentaje_logro REAL,
    concepto TEXT,
    nota REAL,
    escala TEXT,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE CASCADE
);

CREATE TABLE IF NOT EXISTS materiales (
    id TEXT PRIMARY KEY,
    asignatura_id TEXT NOT NULL,
    tipo TEXT NOT NULL,
    ruta_relativa TEXT NOT NULL,
    nombre TEXT NOT NULL,
    tags TEXT,
    fecha_agregado TEXT NOT NULL,
    url_r2 TEXT,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE CASCADE
);

CREATE TABLE IF NOT EXISTS eventos_calendario (
    id TEXT PRIMARY KEY,
    tipo TEXT NOT NULL,
    asignatura_id TEXT,
    fecha TEXT NOT NULL,
    descripcion TEXT NOT NULL,
    hora TEXT,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE CASCADE
);

CREATE TABLE IF NOT EXISTS carpetas_notas (
    id TEXT PRIMARY KEY,
    nombre TEXT NOT NULL,
    color TEXT,
    padre_id TEXT,
    fecha_creacion TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS notas_generales (
    id TEXT PRIMARY KEY,
    titulo TEXT NOT NULL,
    contenido TEXT NOT NULL,
    carpeta_id TEXT,
    asignatura_id TEXT,
    evento_id TEXT,
    tags TEXT,
    en_papelera INTEGER DEFAULT 0,
    fecha_creacion TEXT NOT NULL,
    fecha_modificacion TEXT NOT NULL,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE SET NULL,
    FOREIGN KEY(carpeta_id) REFERENCES carpetas_notas(id) ON DELETE SET NULL,
    FOREIGN KEY(evento_id) REFERENCES eventos_calendario(id) ON DELETE SET NULL
);

CREATE TABLE IF NOT EXISTS horarios_clases (
    id TEXT PRIMARY KEY,
    asignatura_id TEXT NOT NULL,
    dia TEXT NOT NULL CHECK (dia IN ('lunes', 'martes', 'miercoles', 'jueves', 'viernes')),
    hora_inicio TEXT NOT NULL,
    hora_fin TEXT NOT NULL,
    grupo TEXT,
    salon TEXT,
    docente TEXT,
    observaciones TEXT,
    periodo TEXT,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id)
);

CREATE TABLE IF NOT EXISTS historial_academico (
    id TEXT PRIMARY KEY,
    asignatura_id TEXT NOT NULL,
    fecha TEXT NOT NULL DEFAULT '',
    instancia TEXT NOT NULL CHECK (instancia IN ('curso_reglamentado', 'examen_libre')),
    resultado TEXT NOT NULL CHECK (resultado IN ('aprobado', 'reprobado')),
    calificacion INTEGER,
    FOREIGN KEY(asignatura_id) REFERENCES asignaturas(id) ON DELETE CASCADE
);

CREATE INDEX IF NOT EXISTS idx_evaluaciones_asignatura ON evaluaciones(asignatura_id);
CREATE INDEX IF NOT EXISTS idx_historial_asignatura ON historial_academico(asignatura_id);
CREATE INDEX IF NOT EXISTS idx_eventos_asignatura ON eventos_calendario(asignatura_id);
CREATE INDEX IF NOT EXISTS idx_notas_asignatura ON notas_generales(asignatura_id);
CREATE INDEX IF NOT EXISTS idx_notas_carpeta ON notas_generales(carpeta_id);
CREATE INDEX IF NOT EXISTS idx_materiales_asignatura ON materiales(asignatura_id);
CREATE INDEX IF NOT EXISTS idx_horarios_asignatura ON horarios_clases(asignatura_id);
CREATE INDEX IF NOT EXISTS idx_asignaturas_plan ON asignaturas(plan_id);
CREATE INDEX IF NOT EXISTS idx_asignaturas_modulo ON asignaturas(modulo_id);
CREATE INDEX IF NOT EXISTS idx_asignaturas_ciclo ON asignaturas(ciclo_id);
CREATE INDEX IF NOT EXISTS idx_carreras_facultad ON carreras(facultad_id);
CREATE INDEX IF NOT EXISTS idx_modulos_facultad ON modulos(facultad_id);
CREATE INDEX IF NOT EXISTS idx_ciclos_facultad ON ciclos(facultad_id);
`;

export const MIGRATIONS = [
  "ALTER TABLE evaluaciones ADD COLUMN porcentaje_logro REAL;",
  "ALTER TABLE evaluaciones ADD COLUMN concepto TEXT;",
  "ALTER TABLE evaluaciones ADD COLUMN escala TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN porcentaje_logro REAL;",
  "ALTER TABLE asignaturas ADD COLUMN concepto_final TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN posicion_x REAL;",
  "ALTER TABLE asignaturas ADD COLUMN posicion_y REAL;",
  "ALTER TABLE asignaturas ADD COLUMN eva_url TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN sala9_url TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN fecha_inicio TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN fecha_fin TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN ano_cursado INTEGER;",
  "ALTER TABLE asignaturas ADD COLUMN en_papelera INTEGER DEFAULT 0;",
  "ALTER TABLE asignaturas ADD COLUMN eliminado_en TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN es_opcional INTEGER DEFAULT 0;",
  "ALTER TABLE asignaturas ADD COLUMN dictado TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN previas_sugeridas TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN calificacion_oficial INTEGER;",
  "ALTER TABLE asignaturas ADD COLUMN aplazos TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN modulo_id TEXT;",
  "ALTER TABLE asignaturas ADD COLUMN ciclo_id TEXT;",
  "ALTER TABLE notas_generales ADD COLUMN titulo TEXT DEFAULT '';",
  "ALTER TABLE notas_generales ADD COLUMN carpeta_id TEXT;",
  "ALTER TABLE notas_generales ADD COLUMN asignatura_id TEXT;",
  "ALTER TABLE notas_generales ADD COLUMN evento_id TEXT;",
  "ALTER TABLE notas_generales ADD COLUMN tags TEXT;",
  "ALTER TABLE notas_generales ADD COLUMN en_papelera INTEGER DEFAULT 0;",
  "ALTER TABLE notas_generales ADD COLUMN eliminado_en TEXT;",
  "ALTER TABLE eventos_calendario ADD COLUMN hora TEXT;",
  "ALTER TABLE horarios_clases ADD COLUMN periodo TEXT;",
  "ALTER TABLE materiales ADD COLUMN url_r2 TEXT;",
  "ALTER TABLE carreras ADD COLUMN modo_vacio_confirmado INTEGER DEFAULT 0;",
  "CREATE INDEX IF NOT EXISTS idx_evaluaciones_asignatura ON evaluaciones(asignatura_id);",
  "CREATE INDEX IF NOT EXISTS idx_historial_asignatura ON historial_academico(asignatura_id);",
  "CREATE INDEX IF NOT EXISTS idx_eventos_asignatura ON eventos_calendario(asignatura_id);",
  "CREATE INDEX IF NOT EXISTS idx_notas_asignatura ON notas_generales(asignatura_id);",
  "CREATE INDEX IF NOT EXISTS idx_notas_carpeta ON notas_generales(carpeta_id);",
  "CREATE INDEX IF NOT EXISTS idx_materiales_asignatura ON materiales(asignatura_id);",
  "CREATE INDEX IF NOT EXISTS idx_horarios_asignatura ON horarios_clases(asignatura_id);",
  "CREATE INDEX IF NOT EXISTS idx_asignaturas_plan ON asignaturas(plan_id);",
  "CREATE INDEX IF NOT EXISTS idx_asignaturas_modulo ON asignaturas(modulo_id);",
  "CREATE INDEX IF NOT EXISTS idx_asignaturas_ciclo ON asignaturas(ciclo_id);",
  "CREATE INDEX IF NOT EXISTS idx_carreras_facultad ON carreras(facultad_id);",
  "CREATE INDEX IF NOT EXISTS idx_modulos_facultad ON modulos(facultad_id);",
  "CREATE INDEX IF NOT EXISTS idx_ciclos_facultad ON ciclos(facultad_id);"
];

